

















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { firestore } from "@/scripts/firebase";
import { Message, JinroPlayerDocument } from "@/services/datatypes";
import { ToastProgrammatic as Toast } from "buefy";
import { PUBLIC_VIEWER_POSTER_NAME_SUFFIX } from "@/services/constants";
import { DialogProgrammatic as Dialog } from "buefy";

@Component({
  components: {},
})
export default class PublicViewerPosterName extends Vue {
  @Prop() readonly refChatroom!: firebase.firestore.CollectionReference;
  newMessage = "";
  posterTmpName = this.userName ? this.userName : "名無し";

  get posterName(): string {
    if (this.hasUser) {
      return this.userName;
    }

    return this.posterTmpName;
  }
  get userName(): string {
    if (this.$store.state.user) {
      return this.$store.state.user.displayName;
    }
    return "";
  }

  get hasUser(): boolean {
    return !!this.$store.state.firebaseUser;
  }

  get jinroPlayer(): JinroPlayerDocument | null {
    if (this.$store.state.jinroPlayer) {
      return this.$store.state.jinroPlayer;
    }

    return null;
  }

  get isFormBlank(): boolean {
    return this.newMessage === "";
  }

  get userUid(): string | undefined {
    if (this.$store.state.firebaseUser) {
      return this.$store.state.firebaseUser.uid;
    }

    return undefined;
  }

  get isPublicViewing(): boolean {
    // public view path example:  /j/TAYBteCF9uJnFVyUtP8W/public
    const elmnts = this.$route.path.split("/");

    return elmnts.length > 3 && this.$route.path.split("/")[3] === "public";
  }

  get uid() {
    if (this.isPublicViewing || !this.jinroPlayer) {
      return this.userUid ? this.userUid : null;
    }
    return this.jinroPlayer.uid;
  }

  async handlePost() {
    if (this.isFormBlank) {
      return;
    }
    const newMessage = this.newMessage;
    this.newMessage = "";

    const params = {
      playerId: null,
      fromPublicViewing: true,
      playerName: this.posterName,
      uid: this.uid,
      timeCreated: firestore.FieldValue.serverTimestamp(),
      message: newMessage,
    };
    await this.refChatroom.add(params);
  }
  get suffix(): string {
    return PUBLIC_VIEWER_POSTER_NAME_SUFFIX;
  }

  changePosterName() {
    Dialog.prompt({
      message: `${this.posterName}${this.suffix} を変更します <br/>*必ず「${this.suffix}」が末尾につきます<br/>  *過去の投稿の名前は変更されません `,
      inputAttrs: {
        type: "text",
        placeholder: "新しい名前",
        value: "",
      },
      cancelText: "キャンセル",
      confirmText: "変更する",
      onConfirm: async (value) => this.checkDialogue(value),
    });
  }
  checkDialogue(value: string) {
    Dialog.confirm({
      message: `「${this.posterName}${this.suffix}」から「${value}${this.suffix}」 に変更しますか？`,
      cancelText: "キャンセル",
      confirmText: "変更する",
      onConfirm: () => this.editPosterTmpName(value),
    });
  }
  editPosterTmpName(name: string) {
    this.posterTmpName = name;
    this.$emit("poster-tmp-name", name);
  }
}
